import type { BannerAction } from 'Components/shared/Banner/index.types';

export const PERSISTENT_BANNER_DURATION_MS = 30000;
export const SESSION_KEY_PERSISTENT_AFTER_REFRESH =
  'connectivity_banner_persistent_after_refresh';

export const INITIAL_MESSAGE =
  'Trouble connecting. Calls and messages might be unavailable for you.';
export const PERSISTENT_MESSAGE =
  'Reconnecting. Try to refresh the page or contact support for help.';
export const ONLINE_MESSAGE = "Reconnected. You're all set.";

export const getBannerActions = (
  handleRefresh: () => void,
  handleContactSupport: () => void
): [BannerAction, BannerAction] => [
  { label: 'Refresh', onClick: handleRefresh },
  { label: 'Contact support', onClick: handleContactSupport },
];
